import utils from '@eitje/utils'
import {ftime} from '@eitje/utils'
import {t} from '@eitje/bridge'
import {Text} from '../../../text'

export const DateCell = ({value}) => {
	return <Cell value={value && ftime(value, 'dayMonthYear')} />
}

export const BooleanCell = ({value, column}) => {
	const {defaultValue} = column
	if (value == null && defaultValue == null) return <Cell />
	return <Cell value={value || defaultValue ? t('yes') : t('no')} />
}

export const Cell = ({value, defaultValue = '-'}) => {
	const val = utils.exists(value) ? value : defaultValue
	return <Text truncate>{val}</Text>
}
